import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import { EnhancedDetailPanel } from 'components/enhanced/data-grid/components';
import { memo } from 'react';
import { maintenanceService } from 'shared/services';

type MaintenanceDetailPanelProps = {
  row: {
    contract_id: number;
    contract_equipment_id: number;
  };
  columns: GridColDef[];
};

const MaintenanceDetailPanel = ({ row, columns }: MaintenanceDetailPanelProps) => {
  return (
    <EnhancedDetailPanel>
      <EnhancedDataGrid
        columns={columns}
        service={maintenanceService}
        outerParams={{
          contract_id: row.contract_id,
          contract_equipment_id: row.contract_equipment_id
        }}
      />
    </EnhancedDetailPanel>
  );
};

export default memo(MaintenanceDetailPanel);
